// extracted by mini-css-extract-plugin
export default {"bold":"CardCarrier_bold__-SZV7"};